import Api from '../../services';
import storageService from '../../storage-service';

export const getCurrencies = () => {
  return (dispatch) => {
    return Api.currencies.getCurrencies().then((response) => {
      dispatch({
        type: 'GET_CURRENCIES',
        data: response,
      });
      return response;
    });
  };
};

export const getDefaultCurrency = () => {
  return async (dispatch) => {
    const currency = await storageService.get('currency');
    dispatch({
      type: 'GET_SAVED_CURRENCY',
      data: currency,
    });
    return currency;
  };
};
